<div *ngIf="case && case.type !== CaseType.RENEWAL_MAINTENANCE else maintenanceCase">
  <div class="fx-row justify-content-start align-items-stretch mb-16 fx-flex-100" *ngIf="case">
    <app-case-content [case]="case" [mode]="mode" [propertyOffice]="propertyOffice"
      [trademarkProductsServices]="trademarkProductsServices" [productsServices]="productsServices"
      class="fx-flex-50 mr-8 border-box"></app-case-content>
    <app-case-score [case]="case" [score]="case.score" [style]="'expanded'"
      class="fx-flex-50 ml-8 border-box"></app-case-score>
  </div>
  <div class="fx-row justify-content-start align-items-stretch "
    *ngIf="case && case.documents && case.documents.length > 0">
    <app-case-coverage [case]="case" [count]="count" [propertyOffice]="propertyOffice" class="fx-flex-100 border-box"
      #caseCoverage (toProofs)="toProofs.emit()"></app-case-coverage>
  </div>
</div>

<ng-template #maintenanceCase>
  <div class="maintenanceCase fx-flex fx-row fx-wrap" *ngIf="case">
    <div class="fx-flex-100 fx-flex fx-column">
      <app-case-content class="caseContent" [case]="case" [mode]="mode"
        [propertyOffice]="propertyOffice"></app-case-content>
    </div>
    <div class="fx-flex-100">
      <app-case-renewal-proofs [case]="case" (refresh)="populateClassesAndPs()" [readonly]="case.state === 'CLOSED'"
        [classes]="classes" [trademarkProductsServices]="trademarkProductsServices"
        [productsServices]="productsServices" #caseRenewalProofs>
      </app-case-renewal-proofs>
    </div>
  </div>
</ng-template>